import { useContext, useEffect, useState } from "react";
import { FixedAssetsWriteOffDto } from "../../../../dtos/documents/FixedAssetsWriteOff/FixedAssetsWriteOffDto";
import { FixedAssetsWriteOffModel } from "../../../../models/Documents/FixedAssetsWriteOffsModel/FixedAssetsWriteOffModel";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { Col, Row } from "react-bootstrap";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import FixedAssetsWriteOffsDetailsSkeleton from "./FixedAssetsWriteOffsDetailsSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { FixedAssetsWriteOffsDetailsMain } from "./FixedAssetsWriteOffsDetailsMain";
import { FixedAssetsWriteOffsDetailsProducts } from "./FixedAssetsWriteOffsDetailsProducts";
import { useTranslation } from "react-i18next";
import { FixedAssetsWriteOffsDetailFooter } from "./FixedAssetsWriteOffsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";
interface IProps {
  model: FixedAssetsWriteOffDto | null;
  modelUpdatedEvent: (newModel: FixedAssetsWriteOffDto) => void;
}

const FixedAssetsWriteOffsDetails = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<FixedAssetsWriteOffModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Fixed Assets Write Offs");
  const { t } = useTranslation();

  useEffect(() => {
    console.log(model);

    if (model) {
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("createdDate", model.createdDate);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("companyId", model.companyId);
      setValue("fixedAssets", model.fixedAssets);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: FixedAssetsWriteOffModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <FixedAssetsWriteOffsDetailsSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.FixedAssetsWriteOffs.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>
      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
         <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <FixedAssetsWriteOffsDetailsMain />
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <FixedAssetsWriteOffsDetailsProducts />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={t("Comment")} required={false} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <FixedAssetsWriteOffsDetailFooter/>
    </FormProvider>
  );
};

export default FixedAssetsWriteOffsDetails;
